// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgEdit24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.1746 2.95389L21.2959 5.07521C22.3699 6.14916 22.3699 7.89036 21.2959 8.9643L10.5677 19.6926C10.0522 20.208 9.35324 20.4977 8.62431 20.498L4.50033 20.4998C4.08586 20.5 3.74982 20.164 3.75 19.7495L3.7518 15.6255C3.75211 14.8966 4.04182 14.1976 4.55725 13.6822L15.2855 2.95389C16.3595 1.87995 18.1007 1.87995 19.1746 2.95389ZM14.15 6.21044L5.61791 14.7428C5.38362 14.9771 5.25194 15.2948 5.2518 15.6262L5.25024 18.9996L8.62366 18.998C8.90766 18.9979 9.18166 18.9011 9.40169 18.726L9.507 18.6319L18.0444 10.0957C18.0184 10.0758 17.9934 10.0539 17.9697 10.0302L14.15 6.21044ZM15.21 5.14944L16.3462 4.01455C16.8343 3.5264 17.6258 3.5264 18.114 4.01455L20.2353 6.13587C20.7234 6.62403 20.7234 7.41549 20.2353 7.90364L19.094 9.04444L19.0303 8.96951L15.21 5.14944Z"
			/>
		</Svg>
	);
});
SvgEdit24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgEdit24;
